const PREFIX = "notebook.tools";

export const toolStorage = {
    get(key, fallback) {
        try {
            const raw = window.localStorage.getItem(`${PREFIX}.${key}`);
            return raw == null ? fallback : JSON.parse(raw);
        } catch (_) {
            return fallback;
        }
    },
    set(key, value) {
        try {
            window.localStorage.setItem(`${PREFIX}.${key}`, JSON.stringify(value));
            return true;
        } catch (_) {
            return false;
        }
    },
    remove(key) {
        try {
            window.localStorage.removeItem(`${PREFIX}.${key}`);
        } catch (_) {
            // Local storage can be disabled by the browser.
        }
    },
};

export const safeCopy = async (value) => {
    const text = String(value ?? "");
    if (!text) return false;

    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (_) {
        const area = document.createElement("textarea");
        area.value = text;
        area.setAttribute("readonly", "");
        area.style.position = "fixed";
        area.style.opacity = "0";
        document.body.appendChild(area);
        area.select();
        const copied = document.execCommand("copy");
        document.body.removeChild(area);
        return copied;
    }
};

export const formatBytes = (bytes = 0) => {
    const value = Number(bytes) || 0;
    if (value < 1024) return `${value} B`;
    if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
    return `${(value / 1024 / 1024).toFixed(1)} MB`;
};

export const replaceTemplateVariables = (value, variables = {}) => String(value ?? "").replace(
    /\{\{\s*([A-Za-z_][A-Za-z0-9_]*)\s*\}\}/g,
    (_, key) => Object.prototype.hasOwnProperty.call(variables, key) ? String(variables[key]) : `{{${key}}}`,
);

export const redactHeaders = (headers = {}) => Object.fromEntries(Object.entries(headers).map(([key, value]) => (
    /authorization|cookie|api[-_]?key|token|secret/i.test(key)
        ? [key, "••••••••"]
        : [key, value]
)));
